<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
      @keydown.esc="$emit('unsetSelectedSeat')"
      @click:outside="
        !selectedSeat.reserved
          ? $emit('unsetSelectedSeat')
          : $store.commit('SET_SELECTED_SEAT', null)
      "
    >
      <v-card v-if="selectedSeat">
        <v-card-title>
          <v-row no-gutters align="center">
            <span class="checkout-h3">{{
              selectedSeat.identificacao.replace(";", " - ")
            }}</span>
            <v-icon
              class="mx-3"
              small
              :color="selectedSeat.cor ? selectedSeat.cor : '#e0e0e0'"
              >mdi-checkbox-blank-circle</v-icon
            >
            <span v-if="selectedSeat.tipo !== '9'" class="checkout-h3">{{
              selectedSeat.nome_produto_vinculado
            }}</span>
            <v-spacer></v-spacer>
            <v-icon
              v-if="!selectedSeat.reserved"
              @click="$emit('unsetSelectedSeat')"
              @keypress.esc="$emit('unsetSelectedSeat')"
              >mdi-close</v-icon
            >
            <v-icon v-else @click="$store.commit('SET_SELECTED_SEAT', null)"
              >mdi-close</v-icon
            >
          </v-row>
        </v-card-title>

        <v-row v-if="seatProducts[0].observacoes" class="ml-6" no-gutters>
          <div class="description-box">
            <span class="white--text">
              {{ seatProducts[0].observacoes }}
            </span>
          </div>
        </v-row>

        <v-card-text v-if="!loading" class="pa-0">
          <v-radio-group v-model="option">
            <div
              v-for="(product, index) in selectedSeat.reserved
                ? reservedProduct
                : seatProducts"
              :key="`${product.codigo_produto} + ${index}`"
              :style="!selectedSeat.reserved ? 'cursor: pointer' : ''"
              @click="
                !selectedSeat.reserved
                  ? selectType(product.codigo_tipo)
                  : () => {}
              "
            >
              <v-divider v-if="index === 0"></v-divider>
              <v-row class="px-4 py-3" align="center" no-gutters>
                <v-col cols="10">
                  <h3 class="checkout-h3">{{ product.nome_tipo }}</h3>
                  <h4
                    class="product-price"
                    v-html="productPriceDetails(product)"
                  ></h4>
                  <h4
                    v-if="
                      selectedSeat.tipo === '9' && product.valor_consumacao_lote
                    "
                    style="font-size: 12px; font-weight: 500"
                  >
                    Inclui consumação de
                    {{ product.valor_consumacao_lote | currency }}
                  </h4>
                </v-col>
                <v-spacer></v-spacer>
                <v-radio
                  v-if="!selectedSeat.reserved"
                  :value="product.codigo_tipo"
                  color="#1976d2"
                ></v-radio>
              </v-row>
              <v-divider></v-divider>
            </div>
          </v-radio-group>
        </v-card-text>
        <v-row v-else class="py-6" justify="center" no-gutters>
          <v-progress-circular
            indeterminate
            color="primary"
            size="60"
          ></v-progress-circular>
        </v-row>
        <v-card-actions>
          <v-btn
            v-if="selectedSeat.reserved"
            color="primary"
            text
            rounded
            width="100%"
            @click="removeProduct"
          >
            {{ $t("cart.cartRemove") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["selectedSeat"],
  data() {
    return {
      option: null,
      loading: false,
      reservedProduct: null,
    };
  },
  computed: {
    ...mapGetters(["selectedSector", "cartProducts", "eventId"]),
    dialog() {
      return !!this.selectedSeat;
    },
    seatProducts() {
      return this.selectedSector.products.filter(
        (sc) => sc.codigo_produto === this.selectedSeat.produto_vinculado
      );
    },
  },
  mounted() {
    if (this.selectedSeat.reserved) this.setReservedProduct();
  },
  methods: {
    setReservedProduct() {
      this.reservedProduct = this.selectedSector.products
        .filter((ss) => ss.reserved)
        .map((el) => {
          if (el.seats.includes(this.selectedSeat.codigo_assento)) return el;
          return null;
        })
        .filter((co) => co);
    },
    selectType(code) {
      this.option = code;
      this.addProductInCart();
    },
    async addProductInCart() {
      let product = this.seatProducts.filter(
        (el) => el.codigo_tipo === this.option
      );

      if (!this.selectedSeat.reservado_terminal) {
        this.loading = true;
        await this.$store
          .dispatch("checkIfSeatAvailable", this.selectedSeat)
          .then((resp) => {
            if (
              resp &&
              resp.status &&
              resp.status == 200 &&
              resp.data &&
              resp.data.success
            ) {
              product[0].reserved = true;
              this.selectedSeat.reserved = true;
              this.$store.dispatch("addCartProduct", product[0]);
              localStorage.setItem(
                `sector-selected-${this.eventId}`,
                JSON.stringify(this.selectedSector)
              );
              this.$store.commit("SET_SELECTED_SEAT", null);
            } else {
              this.$store.dispatch("openSnackbar", {
                message: "Erro ao reservar, assento indisponível.",
                color: "error",
              });
              product[0].disponivel = false;
              this.selectedSeat.disponivel = false;
              this.$store.commit("SET_SELECTED_SEAT", null);
            }
            this.loading = false;
          })
          .catch((e) => {
            if (e) {
              this.$store.dispatch("openSnackbar", {
                message: "Erro ao reservar, assento indisponível.",
                color: "error",
              });
              this.$store.commit("SET_SELECTED_SEAT", null);
              this.loading = false;
            }
          });
      } else {
        product[0].reserved = true;
        this.selectedSeat.reserved = true;
        this.$store.dispatch("addCartProduct", product[0]);
        localStorage.setItem(
          `sector-selected-${this.eventId}`,
          JSON.stringify(this.selectedSector)
        );
        this.$store.commit("SET_SELECTED_SEAT", null);
      }
    },
    async removeProduct() {
      await this.$store.dispatch("removeCartProduct", this.reservedProduct[0]);
      this.$emit("unsetSelectedSeat");
      if (this.reservedProduct[0].quantidade === 1)
        this.reservedProduct[0].reserved = false;
    },
    productPriceDetails(product) {
      const value = this.$options.filters.currency(product.valor);
      const tax = product.valor_conveniencia
        ? ` + ${this.$options.filters.currency(
            product.valor_conveniencia
          )} taxa`
        : "";
      const lote = ` (Lote ${product.lote})`;
      if (product.cupom === 0)
        return `<span style="font-size: 16px; color: #1976d2">${value}</span><span style="font-size: 12px; font-weight: 500">${tax}${
          this.eventDetails && this.eventDetails.exibir_lote ? lote : ""
        }</span>`;
      else
        return `<span style="font-size: 16px; color: #00A65A">${value}</span> <span style="font-size: 12px; font-weight: 500">${tax}${
          this.eventDetails && this.eventDetails.exibir_lote ? lote : ""
        }</span>`;
    },
  },
};
</script>

<style scoped>
.description-box {
  background-color: orange;
  padding: 10px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
